export function LocationMarker() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="z-[99999999999] animate-bounce"
    >
      <circle cx="10" cy="10" r="9.5" fill="#D9D9D9" stroke="#113841" />
      <circle cx="10" cy="10" r="5" fill="#113841" />
    </svg>
  );
}
